<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="halftitle"></a><a id="page_i"></a><strong>T.H.U.G. L.I.F.E.</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?401fd044